<template>
  <div :loading="saveLoad" class="app-container">
    <div class="materialFormLine">广宣物料信息修改</div>
    <div class="budgetBox">
      <a-form-model ref="material" class="UniformCss form-container" :inline="true" :model="material" :rules="rules" label-width="100px">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="物料号" prop="materialCode">
              <a-input v-model="material.materialCode" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="物料名称" prop="materialName">
              <a-input v-model="material.materialName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="物料类型" prop="materialType">
              <a-select v-model="material.materialType" >
                <a-select-option v-for="item in SelectLists.PromotionMaterialType" :key="item.code" :value="item.code" >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="库存量" prop="storage">
              <a-input v-model="material.storage" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="所属仓库" prop="warehouse">
              <a-select v-model="material.warehouse">
                <a-select-option v-for="item in SelectLists.PromotionStockType" :key="item.code" :value="item.code" >{{ item.value }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-model-item label="申领单价（元）" prop="price">
              <a-input v-model="material.price" disabled type="number"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="制作单价（元）" prop="prodPrice">
              <a-input v-model="material.prodPrice"  type="number"/>
            </a-form-model-item>
          </a-col>
          <!-- lr0015 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="供应商" prop="supplier">
              <a-input v-model="material.supplier" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="物料规格" prop="specification">
              <a-input v-model="material.specification" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-model-item label="单位" prop="unit">
              <a-input v-model="material.unit" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="安全库存" prop="storageSafetyValue">
              <a-input-number v-model="material.storageSafetyValue" :min="0" :precision="0" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="物料说明" prop="caption">
              <a-input v-model="material.caption" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-model-item label="备注" prop="remark">
              <!-- <a-input v-model="material.remark" /> -->
              <a-textarea v-model="material.remark" :rows="1" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <!-- :file-list="fileList" - 绑定已上传文件列表 -->
            <!-- :on-remove="handleRemove" - 删除图片时触发的方法
            :on-change="onChangeImg" - 文件状态改变时触发的方法
            :on-preview="handlePreview" - 点击预览图片时触发的方法 -->
            <!-- multiple - 允许多文件上传 -->

            <a-form-model-item label="物料图片">
              <el-upload
                ref="upload"
                class="upload-demo"
                accept=".jpg,.png"
                :limit="4"
                action=""
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="onChangeImg"
                :file-list="fileList"
                multiple
                :auto-upload="false">
                <i class="el-icon-plus" />
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，每张不超过2M，最多上传4张，照片名称不可重复</div>
              </el-upload>
              <a-modal width="40%" v-model="dialogVisible" :footer="null">
                <img width="100%" :src="dialogImageUrl" alt="">
              </a-modal>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="btn-container">
        <vxe-button @click="returnFun()">返回</vxe-button>
        <vxe-button status="primary" @click="onSubmit()">保存</vxe-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getMaterialById, getImgs, updateMaterial } from '@/api/material'
import { setInitImg } from '@/utils/Picture/transferFile'

export default {
  name: 'EditMaterial',
  data() {
    return {
      material: {},
      rules: {
        materialCode: [{ required: true, message: '请输入物料编号', trigger: 'blur' }],
        materialName: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        materialType: [{ required: true, message: '请选择物料类型', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        storage: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        // warehouse: [{ required: true, message: '请选择所属仓库', trigger: 'blur' }],
        price: [{ required: true, message: '请输入申领价', trigger: 'blur' }],
        prodPrice: [{ required: true, message: '请输入制作价', trigger: 'blur' }],
        // supplier: [{ required: true, message: '请输入供应商', trigger: 'blur' }]
        storageSafetyValue: [{ required: true, message: '请输入安全库存）', trigger: 'blur' }],
      },
      dialogImageUrl: '',
      dialogVisible: false,
      saveLoad: false,
      SelectLists: {},
      fileType: ['image/png', 'image/jpeg'],
      fileList: [],
      disabled: false,
      fileNames: ''
    }
  },
  created() {
    this.material.id = this.$route.params.id
    if (this.$route.params.id) {
      this.getMaterialDetail()
      this.SelectListFun()
    }
  },
  methods: {
    getMaterialDetail() {
      const id = this.material.id
      this.saveLoad = true
      getMaterialById(id).then(res => {
        if (res.code === 1) {
          this.material = res.data.material
                  // 判断返回数据中fileNames数组是否有元素
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            console.log(this.fileNames,"this.fileNames")
            this.inItImages()
          }
        } else {
          this.$message.error(res.message)
        }
        this.saveLoad = false
      })
    },
    onSubmit() {
      this.$refs.material.validate((valid) => {
        if (valid) {
          // 创建FormData对象用于文件上传
          let formData = new FormData()
          console.log('@', this.fileList)
          // 遍历上传的文件列表  将每个文件的原始数据添加到formData
          this.fileList.forEach(item => {
            if (item.raw) {
              formData.append('file', item.raw)
            } else if (item.originFileObj) {
              formData.append('file', item.originFileObj)
            }
          })
          // 将物料数据转为JSON字符串
          const data = JSON.stringify(this.material)
          // 物料数据作为Blob添加到formData
          formData.append('material', new Blob([data], { type: 'application/json' }))
          this.saveLoad = true
          updateMaterial(formData).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.returnFun()
            } else {
              this.$message.error(res.message)
            }
            this.saveLoad = false
          })
        } else {
          this.$message.error('请完善物料信息!')
        }
      })
          console.log("🚀 ~ this.$refs.material.validate ~ this.fileList:", this.fileList)
    },
    returnFun() {
      // this.deleteRouter()
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/publicizeMaterialManagement/editMaterial', '/publicizeMaterialManagement/publicizeMaterialMaintenance')
    },
    // deleteRouter() {
    //   // 删除上个标签页
    //   const visitedViews = this.$store.state.tagsView.visitedViews
    //   this.$store.state.tagsView.visitedViews = visitedViews.filter(v => {
    //     return v.path !== this.$route.path
    //   })
    // },
    // 获取下拉列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    },
    // uploadBefore(file) {

    // },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    onChangeImg(file, fileList) {
      const type = file.raw.type
      const isCorrectType = this.fileType.find(item => item === type)
      console.log(fileList,'fileList')
      if (!isCorrectType) {
        this.$message('图片仅支持jpg或png格式')
        fileList.pop()
      } else {
        const size = file.size / 1024 / 1024
        if (size > 2) {
          this.$message('图片大小不得超过2M')
          fileList.pop()
        } else {
          this.fileList = fileList
        }
      }
    },
    inItImages() {
          // 遍历组件中的fileNames数组，对每个文件名执行回调函数
      this.fileNames.forEach(name => {
            // 构造请求数据对象，包含文件名和当前物料的materialCode
        const data = { 
          fileName: name, 
          materialCode: this.material.materialCode
        }
        getImgs(data).then(res => {
          // 调用setInitImg方法处理API返回结果和文件名
      // 生成文件对象(可能是格式化图片数据)
          const file = setInitImg(res, name)
          console.log(this.file,"file")
          this.fileList.push(file)
          console.log(this.fileList,"fileList")
          this.saveLoad = false
        })
      })
    }
  }
}

// inItImages(row) {
//   if (!this.fileNames || this.fileNames.length === 0) 
//       return;
//   // 临时数组存储新图片
//   const newPics = [];
//   this.fileNames.forEach(name => {
//     const data = {
//       fileName: name,
//       materialCode: row.materialCode // 使用当前行的materialCode
//     }
//     getImgs(data).then(res => {
//       const file = setInitImg(res, name)
//       // 检查是否已存在
//       if (!this.picList.some(p => p.name === file.name)) {
//         newPics.push(file);
//       }
//       // 当所有图片处理完成
//       if (newPics.length === this.fileNames.length) {
//         this.picList = [...newPics]; // 替换整个数组
//       }
//       this.saveLoad = false;
//     })
//   })
// },

</script>

<style lang="less" scoped>
.materialFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.btn-container {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
/deep/ .el-upload__input {
  display: none!important;;
}
</style>
